module.exports = __webpack_public_path__ + "static/media/footer.5f596c99.png";